<template>
  <div>
    <Header />

    <div class="container-fluid users-container">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <DivvyAdminSidebar />
        </div>

        <transition appear name="fade">
          <div class="col-md-9 right-container">
            <div class="col-md-12 pt-4">
              <!--  -->
              <div class="border rounded p-2">
                <p style="color: black;">
                  Are you absolutely sure you want to delete this client?
                </p>
                <p style="color: black;">
                  All users for this client will also be deleted.
                </p>
                <button
                  class="btn btn-danger mr-1"
                  style="color: white;"
                  @click="deleteClient"
                >
                  Delete Client
                </button>
                <router-link
                  :to="{
                    name: 'EditClient',
                    params: { Id: this.$route.params.Id },
                  }"
                  class="btn btn-primary"
                  >Cancel</router-link
                >
              </div>
              <!--  -->
            </div>
          </div>
        </transition>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import DivvyAdminSidebar from "@/views/divvyadmin/divvyAdminSidebar.vue";

export default {
  name: "ClientDeleteScreen",
  components: {
    Header,
    Footer,
    DivvyAdminSidebar,
  },
  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch("divvyAdminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "manageClients",
        activeMenu: this.activeMenu ? this.activeMenu : "clientusermanagement",
      });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    deleteClient() {
      this.$store
        .dispatch("manageClients/removeClient", {
          clientId: this.$route.params.Id,
        })
        .then(() => {
          this.$router.push({
            name: "ManageClients",
          });
        });
    },
  },
  created() {
    this.scrollToTop();
    this.setActiveMenuItem();
    
  },
};
</script>

<style lang="scss" scoped>
.users-container {
  min-height: 100%;
  margin: -14px 0 0 0;
}
</style>
